const errorMessages = {
  email: 'Please enter a valid email',
  phone: 'Please enter a valid phone number',
};
export default errorMessages;
